import { motion } from "framer-motion";
import { useScrollAnimate } from "../../../../hooks/useScrollAnimate";
import { useTranslation } from "react-i18next";

export default function MustRead({ read }) {
  const { t } = useTranslation("global");
  const { ref, controls } = useScrollAnimate();

  return (
    <motion.div
      ref={ref}
      variants={{
        hidden: { opacity: 0 },
        visible: { opacity: 1 },
      }}
      initial="hidden"
      animate={controls}
      transition={{
        duration: 0.5,
        delay: 0.5,
      }}
      className="absolute -bottom-20 lg:-bottom-3 md:left-10 xl:left-8 2xl:left-32"
    >
      <div className="relative">
        <motion.div
          className={`border-t-4 shadow-md w-[400px] ${
            !read
              ? "bg-red-100 border-red-500 rounded-b text-red-900"
              : "bg-green-100 border-green-500 rounded-b text-green-900"
          }`}
          initial={
            !read
              ? { backgroundColor: "#fecaca", color: "#b91c1c" }
              : { backgroundColor: "#d1fae5", color: "#064e3b" }
          }
          animate={
            !read
              ? { backgroundColor: "#fecaca", color: "#b91c1c" }
              : { backgroundColor: "#d1fae5", color: "#064e3b" }
          }
          transition={{ duration: 0.5 }}
        >
          <div className="flex px-4 py-4">
            <div className="">
              <svg
                className={`fill-current h-6 w-6 ${
                  !read ? "text-red-500" : "text-green-500"
                } mr-4`}
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
              >
                <path d="M2.93 17.07A10 10 0 1 1 17.07 2.93 10 10 0 0 1 2.93 17.07zm12.73-1.41A8 8 0 1 0 4.34 4.34a8 8 0 0 0 11.32 11.32zM9 11V9h2v6H9v-4zm0-6h2v2H9V5z" />
              </svg>
            </div>
            <div>
              <p className="font-bold">
                {!read
                  ? t("warningsSection.notReadMessage")
                  : t("warningsSection.readMessage")}
              </p>
            </div>
          </div>
        </motion.div>

        {!read && (
          <motion.div
            variants={{
              hidden: { opacity: 0 },
              visible: { opacity: 1 },
            }}
            initial="hidden"
            animate={controls}
            transition={{
              duration: 0.5,
              delay: 0.5,
            }}
            className="rotate-[280deg] absolute -top-40 left-0 hidden xl:block"
          >
            <Arrow />
          </motion.div>
        )}

        {read && (
          <div className="rotate-[10deg] absolute -bottom-10 -right-60">
            <Arrow />
          </div>
        )}
      </div>
    </motion.div>
  );
}

function Arrow() {
  return (
    <svg
      width="250"
      height="90"
      viewBox="0 0 285 118"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M-5.04369e-05 16.3481C23.1319 -2.25672 101.507 -4.82142 149.365 10.5526C201.129 27.0532 226.801 45.5042 271.759 99.1C272.766 94.9409 273.226 91.4529 274.173 88.4228C275.105 84.9233 276.126 81.2337 277.825 78.0914C278.268 77.141 280.79 76.2339 282.027 76.5796C283.265 76.9254 284.56 79.1491 284.5 80.2782C283.692 91.0103 282.502 101.564 281.414 112.397C280.954 115.885 278.741 117.63 275.042 117.062C261.174 114.299 247.218 111.725 233.248 108.682C230.11 107.913 227.017 105.545 223.186 103.759C230.062 97.0136 236.514 101.179 242.468 101.41C248.703 101.54 254.878 102.8 262.645 103.644C251.713 85.5865 238.727 71.4313 223.632 59.3007C168.464 14.5984 104.979 0.7322 35.7945 10.5908C26.7723 11.9379 17.97 14.3134 9.05069 15.9399C6.50072 15.908 4.14225 15.9654 -5.04369e-05 16.3481Z"
        fill="#C8102E"
      />
    </svg>
  );
}
